import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './SecondaryNavbar.css';

const SecondaryNavbar = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const menuItems = [
    { label: t('home'), to: '/' },
    { label: t('ourServices'), href: '#our-services' },
    { label: t('tripExamples'), href: '#trip-examples' },
    { label: t('customerReviews'), href: '#customer-reviews' },
    { label: t('packagePricing'), href: '#package-pricing' },
    { label: t('bookingSteps'), href: '#booking-steps' },
    { label: t('carWithDriver'), href: '#car-with-driver' },
    { label: t('contactUs'), href: '#contact-us' },
  ];

  // Check if device is mobile
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const handleMenuClick = (href) => (e) => {
    if (href && href.startsWith('#')) {
      e.preventDefault();
      if (location.pathname !== '/') {
        navigate('/' + href);
      } else {
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // Close mobile menu after clicking
    if (isMobile) {
      setIsMobileMenuOpen(false);
    }
  };

  const handleHomeClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    // Close mobile menu after clicking
    if (isMobile) {
      setIsMobileMenuOpen(false);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="secondary-navbar">
      <div className="secondary-navbar__container">
        <Link to="/" className="secondary-navbar__logo-link" onClick={handleHomeClick}>
          <div className="secondary-navbar__logo">
            <img src={process.env.PUBLIC_URL + '/2.png'} alt="Logo 2" className="secondary-navbar__logo-img" />
            <img src={process.env.PUBLIC_URL + '/3.png'} alt="Logo 3" className="secondary-navbar__logo-img secondary-navbar__logo-img--large" />
          </div>
        </Link>
        
        {/* Mobile menu toggle button */}
        <button 
          className="secondary-navbar__mobile-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>

        <ul className={`secondary-navbar__menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          {menuItems.map((item, idx) => (
            <li key={idx} className="secondary-navbar__menu-item">
              {item.to ? (
                <Link to={item.to} onClick={item.to === '/' ? handleHomeClick : undefined}>
                  {item.label}
                </Link>
              ) : (
                <a href={item.href} onClick={handleMenuClick(item.href)}>
                  {item.label}
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SecondaryNavbar; 